<template>
  <div id="app">
    <v-app>
      <v-content>
        <router-tabs>
          <div slot="content">
            <router-view></router-view>
          </div>
        </router-tabs>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import 'vuetify/dist/vuetify.min.css';
import { queryStringParser } from '@/utility';
import RouterTabs from '@/components/RouterTabs';

export default {
  name: 'App',
  components: {
    RouterTabs,
  },
  data() {
    return {
    };
  },
  created() {
    const qp = queryStringParser.parse(window.location.search) || {};
    if (qp.slaveId) this.updateConfig(qp.slaveId);
  },
  methods: {
    ...mapActions([
      'updateConfig',
    ]),
  },
};
</script>

<style>
html,
body {
  min-height: 100vh;
}

#app {
  background: #ffffff;
  min-height: 100vh;
}

::-webkit-scrollbar {
  width: 0px;
}
</style>
